// extracted by mini-css-extract-plugin
module.exports = {"traitTier":"traitTier_traitTier__LCWBX","majorIcons":"traitTier_majorIcons__2TrpQ"};